import type { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { getSymbolStyles } from '@/components/CampaignSymbol';
import { getTokenInfo } from '@/utils';

type Props = {
  symbol: string;
  size?: 'xs' | 'small' | 'medium' | 'large';
};

const CryptoEntity: FC<Props> = ({ symbol, size = 'small' }) => {
  const { icon, label } = getTokenInfo(symbol);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {icon && (
        <Box
          component="img"
          src={icon}
          alt={label}
          sx={{
            width: getSymbolStyles(size).image.size,
            height: getSymbolStyles(size).image.size,
            border: getSymbolStyles(size).image.border,
            borderRadius: '100%',
          }}
        />
      )}
      <Typography
        sx={{
          color: 'neutral.100',
          ...getSymbolStyles(size).text,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default CryptoEntity;
